<template>
  <div :id="'editDiv'+ module.widgets_id" class="edit-div" v-html="innerText" :contenteditable="canEdit" @focus="isLocked = true" @blur="isLocked = false" @input="changeText" ></div>
</template>
<script type="text/ecmascript-6">
import i18n from '../../language/index'

export default{
    name: 'editDiv',
    props: {
      value: {
        type: String,
        default: i18n.t('components_my_div_edit_index_2302')
      },
      canEdit: {
        type: Boolean,
        default: true
      },
      module:{
        type: Object,
        default: null
      }
    },
    data(){
      return {
        innerText: this.value,
        isLocked: false
      }
    },
    watch: {
      'value'(val){
        this.innerText = val;
      },
      isLocked(val){
        console.log(val)
        if(this.$el.innerHTML==='' &&!val){
          this.innerText = i18n.t('components_my_div_edit_index_2302')
        }else if(this.$el.innerHTML===i18n.t('components_my_div_edit_index_2302')){
          this.innerText = ''
        }else{
          this.innerText = this.$el.innerHTML
        }
        if (val) {
            var range = document.createRange();
            range.selectNodeContents(document.getElementById('editDiv'+ this.module.widgets_id));
            window.getSelection().removeAllRanges();
            window.getSelection().addRange(range);
        }else{
          // this.templet.dialog_close()
          window.getSelection().removeAllRanges();
          $('#u' +this.module.widgets_id + ' .edit-div').removeClass('focus')
          
        }


        this.$emit('update:value', this.innerText)
      }
    },
    methods: {
      changeText(){
          // this.$emit('input', this.$el.innerHTML);
      },
      // changeFocus(){

      //   console.log(2)
      //   this.$el.focus()
      // }
    }
}
</script>
<style lang="scss" rel="stylesheet/scss">
.edit-div {
  min-height: 30px;
  width: 100%;
  height: 100%;
  overflow: hidden;
  word-break: break-all;
  outline: none;
  user-select: text;
  white-space: pre-wrap;
  text-align: left;
  &[contenteditable='true'] {
    -webkit-user-modify: read-write-plaintext-only;
    -moz-user-modify: read-write-plaintext-only;
    user-modify: read-write-plaintext-only;
    &:empty:before {
      content: attr(placeholder);
      display: block;
      color: #ccc;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/my_div_edit/index.vue